import { render, staticRenderFns } from "./AgeVerification.vue?vue&type=template&id=c1168a32&scoped=true&"
import script from "./AgeVerification.vue?vue&type=script&lang=ts&"
export * from "./AgeVerification.vue?vue&type=script&lang=ts&"
import style0 from "./AgeVerification.vue?vue&type=style&index=0&id=c1168a32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1168a32",
  null
  
)

export default component.exports